import React, { useState, useRef } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import busStations from "../../Data/BusStations.json";
import {
  RiCalendarLine,
  RiBusLine,
  RiUserLocationLine,
  RiUserLocationFill,
} from "react-icons/ri";

// Custom input component for date picker
const CustomDateInput = React.forwardRef(({ value, onClick }, ref) => (
  <div className="input-group">
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      ref={ref}
      readOnly
      placeholder="Select date"
    />
    <button className="btn btn-secondary" type="button" onClick={onClick}>
      <RiCalendarLine />
    </button>
  </div>
));

const SearchBusPanel = ({ onSearch }) => {
  // Bus search state
  const [fromStation, setFromStation] = useState("MUMBAI");
  const [toStation, setToStation] = useState("PUNE");
  const [fromStationId, setFromStationId] = useState("");
  const [toStationId, setToStationId] = useState("");
  const [travelDate, setTravelDate] = useState(() => {
    const todate = new Date();
    todate.setDate(todate.getDate());
    return todate;
  });
  // const [passengers, setPassengers] = useState(1);
  const [errors, setErrors] = useState({});

  // Station search states
  const [fromStationResults, setFromStationResults] = useState([]);
  const [toStationResults, setToStationResults] = useState([]);
  const fromInputRef = useRef(null);
  const toInputRef = useRef(null);

  // Station search handlers
  const handleFromStationSearch = (e) => {
    const value = e.target.value;
    setFromStation(value);
    if (value.length > 0) {
      const filteredStations = busStations.stationList
        .filter((station) =>
          station.stationName.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10);
      setFromStationResults(filteredStations);
    } else {
      setFromStationResults([]);
    }
  };

  const handleToStationSearch = (e) => {
    const value = e.target.value;
    setToStation(value);
    if (value.length > 0) {
      const filteredStations = busStations.stationList
        .filter((station) =>
          station.stationName.toLowerCase().includes(value.toLowerCase())
        )
        .slice(0, 10);
      setToStationResults(filteredStations);
    } else {
      setToStationResults([]);
    }
  };

  const handleFromStationClick = () => {
    const filteredStations = busStations.stationList.slice(0, 10);
    setFromStationResults(filteredStations);
    fromInputRef.current?.select();
  };

  const handleToStationClick = () => {
    const filteredStations = busStations.stationList.slice(0, 10);
    setToStationResults(filteredStations);
    toInputRef.current?.select();
  };

  const handleFromStationSelect = (station) => {
    setFromStation(station.stationName);
    setFromStationId(station.stationId);
    setFromStationResults([]);
  };

  const handleToStationSelect = (station) => {
    setToStation(station.stationName);
    setToStationId(station.stationId);
    setToStationResults([]);
  };

  // Passenger handlers
  // const handleIncreasePassengers = () => {
  //   if (passengers < 10) {
  //     setPassengers(passengers + 1);
  //   }
  // };

  // const handleDecreasePassengers = () => {
  //   if (passengers > 1) {
  //     setPassengers(passengers - 1);
  //   }
  // };

  // Date handler
  const handleTravelDate = (date) => {
    setTravelDate(date);
  };

  // Validation
  const validate = () => {
    let temp = {};
    temp.fromStation = fromStation === "" ? false : true;
    temp.toStation = toStation === "" ? false : true;
    temp.travelDate = travelDate === null ? false : true;

    if (fromStation === toStation) {
      temp.sameStation = false;
    }

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  // Search handler
  const handleSearch = (e) => {
    e.preventDefault();
    if (validate()) {
      const searchQuery = {
        fromStationCode: fromStationId,
        fromStation: fromStation,
        toStationCode: toStationId,
        toStation: toStation,
        travelDate: moment(travelDate).format("YYYY-MM-DD"),
        // passengers: passengers,
      };
      onSearch(searchQuery);
    }
  };

  return (
    <div className="card-body">
      <div className="row gy-3 gx-lg-2 gx-3 align-items-end">
        {/* <div className="col-12 pb-2 fs-5">
          <RiBusLine className="me-2" />
          SEARCH BUSES
        </div> */}

        {/* From Station */}
        <div className="col-3">
         
          <label className="form-label fw-bold">
                                <RiBusLine className="me-1" />  FROM STATION
                              </label>
          <div className="input-group">
                                <span className="input-group-text bg-light">
                                  <RiBusLine />
                                </span>
            <input
              className="form-control"
              type="text"
              placeholder="Leaving from"
              value={fromStation}
              onChange={handleFromStationSearch}
              onClick={handleFromStationClick}
              onFocus={handleFromStationClick}
              ref={fromInputRef}
            />
            <RiUserLocationLine className="position-absolute top-50 end-0 translate-middle-y me-2" />
          </div>
          {errors.fromStation === false && (
            <div className="validationerror">
              Please select departure station
            </div>
          )}
          {fromStationResults.length > 0 && (
            <ul className="locationListVideo scrollable-list">
              {fromStationResults.map((station) => (
                <li
                  className="locationListVideoItem"
                  key={station.stationId}
                  onClick={() => handleFromStationSelect(station)}
                >
                  {station.stationName}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* To Station */}
        <div className="col-3">

          <label className="form-label fw-bold">
                                <RiBusLine className="me-1" /> TO STATION
                              </label>
          <div className="input-group">
                                <span className="input-group-text bg-light">
                                  <RiBusLine />
                                </span>
            <input
              className="form-control"
              type="text"
              placeholder="Going to"
              value={toStation}
              onChange={handleToStationSearch}
              onClick={handleToStationClick}
              onFocus={handleToStationClick}
              ref={toInputRef}
            />
            <RiUserLocationFill className="position-absolute top-50 end-0 translate-middle-y me-2" />
          </div>
          {errors.toStation === false && (
            <div className="validationerror">
              Please select destination station
            </div>
          )}
          {errors.sameStation === false && (
            <div className="validationerror">
              Departure and destination cannot be same
            </div>
          )}
          {toStationResults.length > 0 && (
            <ul className="locationListVideo scrollable-list">
              {toStationResults.map((station) => (
                <li
                  className="locationListVideoItem"
                  key={station.stationId}
                  onClick={() => handleToStationSelect(station)}
                >
                  {station.stationName}
                </li>
              ))}
            </ul>
          )}
        </div>

        {/* Travel Date */}
        <div className="col-2">
          <label htmlFor="travelDate" className="form-label">
            JOURNEY DATE
          </label>
          <DatePicker
            selected={travelDate}
            onChange={handleTravelDate}
            customInput={<CustomDateInput />}
            dateFormat="dd-MMM-yyyy"
            showYearDropdown
            showMonthDropdown
            dropdownMode="select"
            minDate={new Date()}
            yearDropdownItemNumber={50}
            scrollableYearDropdown
            className="form-control"
            placeholder="Journey Date"
          />
          {errors.travelDate === false && (
            <div className="validationerror">Please select journey date</div>
          )}
        </div>

        {/* Passengers */}
        {/* <div className="col-2">
          <label htmlFor="passengers" className="form-label">
            PASSENGERS
          </label>
          <div className="input-group">
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={handleDecreasePassengers}
              disabled={passengers <= 1}
            >
              -
            </button>
            <input
              type="text"
              className="form-control text-center"
              value={`${passengers} ${passengers === 1 ? "Seat" : "Seats"}`}
              readOnly
            />
            <button
              className="btn btn-outline-secondary"
              type="button"
              onClick={handleIncreasePassengers}
              disabled={passengers >= 10}
            >
              +
            </button>
          </div>
        </div> */}

        {/* Search Button */}
        <div className="col-2">
          <div className="form-group mb-0">
            <button
              type="button"
              className="btn btn-danger w-100 fw-medium"
              onClick={handleSearch}
              style={{ height: "38px" }}
            >
              SEARCH
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBusPanel;
